import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface WelcomeScreenProps {
  onHowToPlay: () => void;
  onLetsPlay: () => void;
  className?: string;
}

/**
 * Circus Daily welcome — Figma 10329:27058 (picks/mobile/splash).
 * Close control intentionally omitted for now.
 */
const WelcomeScreen: React.FC<WelcomeScreenProps> = ({
  onHowToPlay,
  onLetsPlay,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <div
      data-test-id="welcome-screen"
      className={`fixed inset-0 flex flex-col bg-surface-page ${className}`}
    >
      <div className="flex flex-1 flex-col items-center justify-center gap-12 px-6">
        <img
          data-test-id="welcome-logo"
          src="/circus-daily-logo-vert.svg"
          alt={t('welcome.altBrand')}
          width={185}
          height={101}
          className="h-[100px] w-[185px] shrink-0 object-contain"
        />

        <div
          data-test-id="welcome-tagline"
          className="w-full text-center font-sans text-2xl font-semibold leading-8 text-white"
        >
          <p>{t('welcome.tagline1')}</p>
          <p>{t('welcome.tagline2')}</p>
          <p>{t('welcome.tagline3')}</p>
        </div>
      </div>

      <div className="flex w-full flex-col gap-4 px-6 pb-10 pt-4">
        <Button
          data-test-id="how-to-play-btn"
          type="button"
          variant="secondary"
          shape="pill"
          size="lg"
          onClick={onHowToPlay}
          className="w-full"
        >
          {t('welcome.howToPlay')}
        </Button>
        <Button
          data-test-id="lets-play-btn"
          type="button"
          variant="primary"
          shape="pill"
          size="lg"
          onClick={onLetsPlay}
          className="w-full"
        >
          {t('welcome.letsPlay')}
        </Button>
      </div>
    </div>
  );
};

export default WelcomeScreen;
